exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.format[data-v-454f64b2]{text-align:left\n}\n.el-row[data-v-454f64b2]{margin-bottom:20px\n}\n@media (max-width: 780px){\n.inputDiv[data-v-454f64b2]{width:260px\n}\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/central/components/cadastro/AppImovelAreaPermutada.vue"],"names":[],"mappings":";AAuEA,yBACE,eAAgB;CACjB;AAAA,yBAEC,kBAAmB;CACpB;AAAA;AAGC,2BACE,WAAY;CACb;CAAA","file":"AppImovelAreaPermutada.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.format {\n  text-align: left;\n}\n.el-row {\n  margin-bottom: 20px;\n}\n\n@media (max-width: 780px) {\n  .inputDiv {\n    width: 260px;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-454f64b2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/central/components/cadastro/AppImovelAreaPermutada.vue
// module id = gaAd
// module chunks = 11